const fsh3 = '32px';
const fslg = '24px';
const fssm = '18px';
const fsxs = '16px';
const fsx = '14px';
const fsXxs = '12px';

const theme = {
  name: 'theme',
  colors: {
    primaryColor: '#0066c4',
    blackColor: '#000000',
    backgroundColor: '#F9FAFB',
    bodyColor: '#f0f2f5',
    labelColor: '#343A40',
    dividerColor: '#D2D9DC',
    whiteColor: '#FFF',
    titleColor: '#373737',
    gray600: '#6C757D',
    borderColor: '#ccc'
  },
  fonts: {
    baseFontSizeH3: fsh3,
    baseFontSizeLg: fslg,
    baseFontSizeSm: fssm,
    baseFontSize: fsxs,
    baseFontSizeMediumSmal: fsx,
    baseFontSizeXs: fsXxs
  },
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700
  }
};

export default theme;
